"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventListener = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
var react_1 = __importDefault(require("react"));
/**
 * Hook that adds and removes Event listeners.
 * @example
 *  useEventListener(
 *     'pointerup',
 *     handlePointerUp,
 *     containerRef.current?.ownerDocument,
 *  );
 */
var useEventListener = function (eventName, handler, element) {
    // Based on published hook https://usehooks.com/useEventListener/.
    var savedHandler = react_1.default.useRef();
    // Update reference if handler changes. This allows our effect below to
    // always use latest handler without us needing to pass it in effect deps array
    // and potentially cause effect to re-run every render.
    react_1.default.useEffect(function () {
        savedHandler.current = handler;
    }, [handler]);
    react_1.default.useEffect(function () {
        if (!element) {
            return;
        }
        var eventListener = function (event) { var _a; return (_a = savedHandler.current) === null || _a === void 0 ? void 0 : _a.call(savedHandler, event); };
        element.addEventListener(eventName, eventListener);
        return function () {
            element.removeEventListener(eventName, eventListener);
        };
    }, [eventName, element]);
};
exports.useEventListener = useEventListener;
